import React, { useState } from "react";
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  updateProfile,
} from "firebase/auth";
import { auth } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import logo from "../logo.png";
import { useAlert } from "../context/AlertContext"; // ✅ eklendi

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { showSuccess, showError } = useAlert(); // ✅ hook kullanımı

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      if (
        user.email === "gozdetaspinar@icloud.com" &&
        (!user.displayName || user.displayName !== "❤️Tuğba Gözde Şimşek❤️")
      ) {
        await updateProfile(user, {
          displayName: "❤️Tuğba Gözde Şimşek❤️",
        });
      } else if (
        user.email === "simsekmahmut90@hotmail.com" &&
        (!user.displayName || user.displayName !== "👑 Mahmut Şimşek 👑")
      ) {
        await updateProfile(user, {
          displayName: "👑 Mahmut Şimşek 👑",
        });
      }

      const displayName = user.displayName || user.email;

      // ✅ Başarı mesajı
      showSuccess(`Hoş geldin, ${displayName}!`, "Keyifli çalışmalar 🎉", {
        emoji: "🔐",
      });

      setTimeout(() => {
        navigate("/");
      }, 2000);
    } catch (err) {
      // ✅ Hata mesajı
      showError("Giriş başarısız", err.message, {
        emoji: "🚫",
      });
    }
  };

  const handleResetPassword = async () => {
    if (!email) {
      showError("Eksik bilgi", "Lütfen önce e-posta adresinizi girin.", {
        emoji: "📧",
      });
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      showSuccess("Şifre sıfırlama e-postası gönderildi", "", {
        emoji: "📩",
      });
    } catch (err) {
      showError("Şifre sıfırlama başarısız", err.message, {
        emoji: "❗",
      });
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleLogin}>
        <img src={logo} alt="Logo" className="login-logo" />
        <h2>Organizasyon Paneli</h2>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="E-posta"
          required
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Şifre"
          required
        />
        <button type="submit">Giriş Yap</button>
        <button
          type="button"
          onClick={handleResetPassword}
          className="reset-button"
        >
          Şifremi Unuttum
        </button>
      </form>
    </div>
  );
}
